import React, { useState, useContext, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Modal, Grid, Typography, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

import FunctionMakeOffer from "./FunctionMakeOffer";
import FunctionEscalate from "./FunctionEscalate";
import FunctionProvideSupportingInfo from "./FunctionProvideSupportingInfo";
import FunctionProvideEvidence from "./FunctionProvideEvidence";
import FunctionAcceptClaim from "./FunctionAcceptClaim";
import FunctionAppeal from "./FunctionAppeal";
import FunctionAcknowledgeReturnedItem from "./FunctionAcknowledgeReturnedItem";

import DisputeContext from "../../../../context/paypal/disputes/DisputeContext";

const PaypalFunctionsModal = ({
  modalOpen,
  setModalOpen,
  order,
  selectedFunction,
  setReturnedMsg,
}) => {
  const disputeContext = useContext(DisputeContext);
  const { dispute } = disputeContext;

  const [state, setState] = useState({
    make_offer: {
      note_value: "",
      amount_value: "",
      refundType_value: "",
      errors: {
        note_value: "",
        amount_value: "",
      },
    },
    escalate: {
      note_value: "",
      errors: {
        note_value: "",
      },
    },
    provide_info: {
      note_value: "",
      errors: {
        note_value: "",
      },
    },
    provide_evidence: {
      evidence_type: "PROOF_OF_FULFILLMENT",
      carrier_name: "OTHER",
      tracking_number: "",
      note_value: "",
      errors: {
        tracking_number: "",
        note_value: "",
      },
    },
    appeal: {
      evidence_type: "PROOF_OF_FULFILLMENT",
      carrier_name: "OTHER",
      tracking_number: "",
      note_value: "",
      errors: {
        tracking_number: "",
        note_value: "",
      },
    },
    accept_claim: {
      note_value: "",
      claim_reason: "",
      amount_value: "",
      errors: {
        note_value: "",
        amount_value: "",
      },
    },
    acknowledge: {
      note_value: "",
      errors: {
        note_value: "",
      },
    },
  });

  const [modalTitle, setModalTitle] = useState();

  function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
    };
  }

  useEffect(() => {
    if (modalOpen === true) {
      if (selectedFunction === "provide_supporting_info") {
        setModalTitle("Provide Supporting Info");
      } else if (selectedFunction === "accept_claim") {
        setModalTitle("Accept Claim");
      } else if (selectedFunction === "appeal") {
        setModalTitle("Appeal");
      } else if (selectedFunction === "provide_evidence") {
        setModalTitle("Provide Evidence");
      } else if (selectedFunction === "escalate") {
        setModalTitle("Escalate");
      } else if (selectedFunction === "make_offer") {
        setModalTitle("Make Offer");
      } else if (selectedFunction === "acknowledge_return_item") {
        setModalTitle("Acknowledge Returned Item");
      }
    }
    //eslint-disable-next-line
  }, [modalOpen]);

  const useStyles = makeStyles((theme) => ({
    paper: {
      position: "absolute",
      width: 1000,
      backgroundColor: "#F7F6F6",
      border: "0px solid #000",
      boxShadow: theme.shadows[5],
    },
    modalHeader: {
      backgroundColor: theme.palette.primary.dark,
      padding: theme.spacing(2),
    },
    headerText: {
      color: theme.palette.primary.contrastText,
    },
  }));

  const classes = useStyles();
  // getModalStyle is not a pure function, roll the style only on the first render
  const [modalStyle] = useState(getModalStyle);

  const handleClose = () => {
    setState((state) => ({
      ...state,
      make_offer: {
        note_value: "",
        amount_value: "",
        refundType_value: "",
        errors: {
          note_value: "",
          amount_value: "",
        },
      },
      escalate: {
        note_value: "",
        errors: {
          note_value: "",
        },
      },
      provide_info: {
        note_value: "",
        errors: {
          note_value: "",
        },
      },
      provide_evidence: {
        evidence_type: "PROOF_OF_FULFILLMENT",
        carrier_name: "OTHER",
        tracking_number: "",
        note_value: "",
        errors: {
          tracking_number: "",
          note_value: "",
        },
      },
      appeal: {
        evidence_type: "PROOF_OF_FULFILLMENT",
        carrier_name: "OTHER",
        tracking_number: "",
        note_value: "",
        errors: {
          tracking_number: "",
          note_value: "",
        },
      },
      accept_claim: {
        note_value: "",
        claim_reason: "",
        amount_value: "",
        errors: {
          note_value: "",
          amount_value: "",
        },
      },
      acknowledge: {
        note_value: "",
        errors: {
          note_value: "",
        },
      },
    }));
    setModalOpen(false);
  };

  return (
    <Modal
      open={modalOpen}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <div style={modalStyle} className={classes.paper}>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className={classes.modalHeader}
        >
          <Grid item>
            <Grid item>
              <Typography variant="h6" className={classes.headerText}>
                <strong> {modalTitle} </strong>{" "}
              </Typography>{" "}
            </Grid>{" "}
          </Grid>{" "}
          <Grid item>
            <IconButton aria-label="expand row" onClick={handleClose}>
              <CloseIcon
                style={{
                  color: "#ffffff",
                }}
              />{" "}
            </IconButton>{" "}
          </Grid>{" "}
        </Grid>{" "}
        <FunctionMakeOffer
          state={state}
          setState={setState}
          dispute={dispute}
          handleClose={handleClose}
          selectedFunction={selectedFunction}
          setReturnedMsg={setReturnedMsg}
        />{" "}
        <FunctionEscalate
          state={state}
          setState={setState}
          dispute={dispute}
          handleClose={handleClose}
          selectedFunction={selectedFunction}
          setReturnedMsg={setReturnedMsg}
        />{" "}
        <FunctionProvideSupportingInfo
          state={state}
          setState={setState}
          dispute={dispute}
          handleClose={handleClose}
          selectedFunction={selectedFunction}
          setReturnedMsg={setReturnedMsg}
        />{" "}
        <FunctionAcknowledgeReturnedItem
          state={state}
          setState={setState}
          dispute={dispute}
          handleClose={handleClose}
          selectedFunction={selectedFunction}
          setReturnedMsg={setReturnedMsg}
        />{" "}
        <FunctionProvideEvidence
          state={state}
          setState={setState}
          dispute={dispute}
          order={order}
          handleClose={handleClose}
          selectedFunction={selectedFunction}
          setReturnedMsg={setReturnedMsg}
        />{" "}
        <FunctionAppeal
          state={state}
          setState={setState}
          dispute={dispute}
          order={order}
          handleClose={handleClose}
          selectedFunction={selectedFunction}
          setReturnedMsg={setReturnedMsg}
        />{" "}
        <FunctionAcceptClaim
          state={state}
          setState={setState}
          dispute={dispute}
          handleClose={handleClose}
          selectedFunction={selectedFunction}
          setReturnedMsg={setReturnedMsg}
        />{" "}
      </div>{" "}
    </Modal>
  );
};

export default PaypalFunctionsModal;
